export default __webpack_public_path__ + "static/media/img_7.b8c86b8d.jpeg";